module.exports = __webpack_public_path__ + "img/89.8b5458b2.jpg";